import { render, staticRenderFns } from "./AttachmentRequirementType.vue?vue&type=template&id=3d90ccf1&scoped=true&"
import script from "./AttachmentRequirementType.vue?vue&type=script&lang=js&"
export * from "./AttachmentRequirementType.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentRequirementType.vue?vue&type=style&index=0&id=3d90ccf1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90ccf1",
  null
  
)

export default component.exports